var _defs, _g, _path, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutShape12(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 115 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#radial-gradient10);\n      }\n\n      .st1 {\n        fill: url(#radial-gradient11);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient);\n      }\n\n      .st3 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st4 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st5 {\n        fill: url(#radial-gradient7);\n      }\n\n      .st6 {\n        fill: url(#radial-gradient13);\n      }\n\n      .st7 {\n        fill: #1a1a1a;\n      }\n\n      .st8 {\n        fill: url(#radial-gradient8);\n      }\n\n      .st9 {\n        fill: url(#radial-gradient12);\n      }\n\n      .st10 {\n        fill: url(#radial-gradient6);\n      }\n\n      .st11 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st12 {\n        fill: gray;\n      }\n\n      .st13 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st14 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st15 {\n        fill: #d1d2d1;\n      }\n\n      .st16 {\n        fill: url(#radial-gradient9);\n      }\n\n      .st17 {\n        display: none;\n        opacity: .23;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 67.61,
    cy: 392.71,
    fx: 67.61,
    fy: 392.71,
    r: 56.77,
    gradientTransform: "translate(-10.58 -333.13) rotate(-.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 57.47,
    cy: 59.5,
    fx: 57.47,
    fy: 59.5,
    r: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 57.47,
    cy: 59.5,
    fx: 57.47,
    fy: 59.5,
    r: 27.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: -48.19,
    cy: 216.78,
    fx: -48.19,
    fy: 216.78,
    r: 3.67,
    gradientTransform: "translate(97.78 -149.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: -40.91,
    cy: 194.79,
    fx: -40.91,
    fy: 194.79,
    r: 3.67,
    gradientTransform: "translate(97.99 -149.37) rotate(-.02)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient5",
    cx: -33.95,
    cy: 216.58,
    fx: -33.95,
    fy: 216.58,
    r: 3.67,
    gradientTransform: "translate(97.78 -149.26)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient6",
    cx: -52.65,
    cy: 203.71,
    fx: -52.65,
    fy: 203.71,
    r: 3.67,
    gradientTransform: "translate(97.96 -149.51)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient7",
    cx: -29.36,
    cy: 203.59,
    fx: -29.36,
    fy: 203.59,
    r: 3.67,
    gradientTransform: "translate(274.82 85.44) rotate(90.01)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient8",
    cx: 57.59,
    cy: 59.26,
    fx: 57.59,
    fy: 59.26,
    r: 44.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient9",
    cx: -47.73,
    cy: 216.42,
    fx: -47.73,
    fy: 216.42,
    r: 3.67,
    gradientTransform: "translate(100.73 -148.79) rotate(.78)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient10",
    cx: -40.45,
    cy: 194.43,
    fx: -40.45,
    fy: 194.43,
    r: 3.67,
    gradientTransform: "translate(100.73 -148.79) rotate(.78)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient11",
    cx: -33.49,
    cy: 216.23,
    fx: -33.49,
    fy: 216.23,
    r: 3.67,
    gradientTransform: "translate(100.73 -148.79) rotate(.78)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient12",
    cx: -52.19,
    cy: 203.35,
    fx: -52.19,
    fy: 203.35,
    r: 3.67,
    gradientTransform: "translate(100.73 -148.79) rotate(.78)",
    xlinkHref: "#radial-gradient3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient13",
    cx: -28.9,
    cy: 203.24,
    fx: -28.9,
    fy: 203.24,
    r: 3.67,
    gradientTransform: "translate(100.73 -148.79) rotate(.78)",
    xlinkHref: "#radial-gradient3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M85.71,13.96l-3.71-2.1,1.74-3.08,3.71,2.1-1.74,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.46,17.26l-3.47-2.48,2.06-2.88,3.46,2.48-2.06,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.8,21.03l-3.18-2.84,2.36-2.64,3.18,2.84-2.36,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.71,25.26l-2.85-3.17,2.63-2.37,2.85,3.17-2.63,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.16,29.9l-2.49-3.46,2.87-2.07,2.49,3.46-2.87,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.08,34.89l-2.11-3.71,3.08-1.75,2.1,3.71-3.08,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.44,40.14l-1.7-3.91,3.25-1.41,1.69,3.91-3.25,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.24,45.63l-1.27-4.07,3.38-1.05,1.27,4.07-3.38,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.44,51.29l-.82-4.18,3.47-.68.82,4.18-3.47.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M111.02,57.06l-.37-4.25,3.53-.31.37,4.25-3.53.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.98,62.8l.09-4.26,3.54.07-.09,4.26-3.54-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.31,68.55l.55-4.23,3.51.46-.55,4.23-3.51-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.02,74.17l1.01-4.14,3.44.84-1.01,4.14-3.44-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.14,79.63l1.45-4.01,3.33,1.2-1.45,4.01-3.33-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.67,84.87l1.87-3.83,3.18,1.55-1.87,3.83-3.18-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M101.68,89.8l2.27-3.61,3,1.88-2.26,3.61-3-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.14,94.41l2.64-3.34,2.78,2.19-2.64,3.34-2.78-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.19,98.54l2.99-3.04,2.53,2.48-2.99,3.04-2.53-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.74,102.29l3.3-2.7,2.24,2.74-3.3,2.7-2.24-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M84.96,105.5l3.57-2.33,1.93,2.97-3.58,2.33-1.93-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M79.85,108.18l3.8-1.93,1.6,3.16-3.8,1.93-1.6-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.47,110.31l3.99-1.51,1.25,3.31-3.99,1.51-1.25-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M68.94,111.83l4.12-1.08.89,3.42-4.13,1.08-.89-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M63.22,112.77l4.22-.63.52,3.5-4.22.63-.52-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M57.42,113.08l4.26-.17.14,3.54-4.26.17-.14-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M51.67,112.76l4.25.29-.24,3.53-4.25-.29.24-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M45.98,111.83l4.2.75-.62,3.48-4.2-.75.62-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40.43,110.29l4.09,1.2-1,3.4-4.09-1.2,1-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M35.03,108.13l3.94,1.64-1.36,3.27-3.94-1.64,1.36-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M29.94,105.44l3.74,2.04-1.7,3.11-3.74-2.04,1.7-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M25.13,102.2l3.5,2.43-2.02,2.91-3.5-2.43,2.02-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M20.72,98.47l3.22,2.8-2.32,2.67-3.22-2.8,2.32-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M16.74,94.3l2.9,3.13-2.6,2.4-2.9-3.13,2.6-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M13.26,89.73l2.54,3.42-2.84,2.11-2.54-3.42,2.84-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M10.26,84.78l2.16,3.68-3.05,1.79-2.16-3.68,3.05-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M7.81,79.53l1.75,3.89-3.23,1.45-1.75-3.89,3.23-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M5.95,74.09l1.32,4.05-3.36,1.1-1.32-4.05,3.36-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M4.67,68.45l.88,4.17-3.46.73-.88-4.17,3.46-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M4.01,62.74l.43,4.24-3.52.36-.43-4.24,3.52-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M3.97,56.92l-.03,4.26-3.54-.03.03-4.26,3.54.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M4.55,51.21l-.49,4.24-3.52-.41.49-4.23,3.52.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M5.76,45.54l-.95,4.16-3.45-.79.95-4.16,3.45.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M7.56,40.07l-1.39,4.03-3.35-1.16,1.39-4.03,3.34,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M9.95,34.81l-1.82,3.86-3.2-1.51,1.82-3.86,3.2,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M12.88,29.83l-2.21,3.64-3.03-1.84,2.21-3.64,3.03,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M16.33,25.19l-2.59,3.38-2.81-2.15,2.59-3.38,2.81,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M20.26,20.96l-2.94,3.08-2.56-2.44,2.94-3.08,2.56,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M24.59,17.2l-3.26,2.75-2.28-2.71,3.26-2.75,2.28,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M29.36,13.89l-3.54,2.38-1.97-2.94,3.54-2.38,1.97,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M34.44,11.14l-3.77,1.98-1.65-3.13,3.77-1.98,1.65,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M39.79,8.93l-3.96,1.57-1.3-3.29,3.97-1.56,1.3,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M45.34,7.32l-4.11,1.13-.94-3.41,4.11-1.13.94,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M51,6.32l-4.21.69-.57-3.49,4.21-.69.57,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M56.75,5.92l-4.26.23-.19-3.53,4.26-.23.19,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M62.54,6.15l-4.25-.23.19-3.53,4.26.23-.19,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M68.24,7l-4.21-.69.57-3.49,4.21.69-.57,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73.84,8.47l-4.11-1.14.95-3.41,4.11,1.14-.95,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M79.22,10.53l-3.96-1.58,1.31-3.29,3.96,1.58-1.31,3.29Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.23,59.44c.03,31.35-25.35,56.79-56.7,56.83-31.35.03-56.79-25.35-56.83-56.7C.67,28.21,26.06,2.77,57.41,2.74c31.35-.03,56.79,25.35,56.83,56.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.97,59.45c.03,24.58-19.87,44.52-44.45,44.55-24.58.03-44.52-19.87-44.55-44.45-.03-24.58,19.87-44.52,44.45-44.55,24.58-.03,44.52,19.87,44.55,44.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M84.62,59.47c.02,14.99-12.13,27.16-27.12,27.18-14.99.02-27.16-12.13-27.18-27.12-.02-14.99,12.13-27.16,27.12-27.18,14.99-.02,27.16,12.13,27.18,27.12Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.92,7.36l5.09.77v.95s-1.72-.26-1.72-.26l-.04,2.9-1.67-.25.04-2.9-1.71-.26v-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.35,8.46l1.66.4-.71,3.72-1.66-.4.71-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M71.35,12.81l1.4-3.53,2.69.9c.5.17.87.32,1.11.47.24.15.41.33.51.54.1.21.1.43.02.65-.08.2-.21.34-.39.44-.18.1-.4.16-.65.17-.16,0-.37,0-.62-.05.18.11.3.2.37.27.05.05.11.14.19.27.08.13.12.23.14.3l.38,1.28-1.83-.61-.44-1.37c-.05-.18-.12-.3-.19-.37-.09-.09-.22-.17-.36-.22l-.14-.05-.57,1.43-1.62-.54ZM73.81,11.26l.68.23c.07.02.22.06.45.1.11.02.22.01.31-.02.09-.04.15-.09.18-.17.04-.11.03-.22-.06-.32-.08-.1-.27-.2-.57-.29l-.71-.24-.28.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M79.05,11.52l4.08,1.92-.48.68-2.55-1.2-.36.51,2.37,1.11-.46.65-2.37-1.12-.45.63,2.63,1.24-.51.72-4.15-1.95,2.25-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M62.78,7.02l5.08.77v.95s-1.72-.26-1.72-.26l-.04,2.9-1.67-.25.04-2.9-1.71-.26v-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M69.21,8.13l1.66.4-.71,3.73-1.66-.4.71-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M71.21,12.48l1.4-3.53,2.69.9c.5.17.87.32,1.11.47.24.15.41.32.51.54.1.21.11.43.02.65-.08.2-.21.34-.39.45-.18.1-.4.16-.65.17-.16,0-.37,0-.62-.05.18.11.3.2.37.27.05.05.11.14.18.27.08.13.12.23.14.29l.38,1.28-1.83-.61-.44-1.37c-.05-.18-.11-.3-.19-.37-.09-.09-.22-.16-.36-.21l-.14-.05-.57,1.43-1.62-.55ZM73.67,10.93l.68.23c.07.02.22.06.45.1.11.02.22.01.31-.02.09-.04.15-.09.18-.17.05-.11.03-.22-.06-.31-.08-.1-.27-.2-.57-.3l-.71-.24-.29.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78.91,11.19l4.08,1.92-.48.68-2.55-1.2-.36.51,2.37,1.12-.46.65-2.37-1.12-.44.63,2.63,1.24-.51.72-4.15-1.95,2.25-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.76,14.77l4.02,2.8-.82.64-1.35-.94-2.49,1.94-1.32-.92,2.49-1.94-1.35-.94.82-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.74,18.4l1.19,1.01-3.81,2.19-1.19-1.01,3.81-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.89,22.23l4.28-1.75,1.71,1.82c.32.34.52.61.62.82.1.21.1.4.02.59-.09.19-.27.34-.54.45-.24.1-.48.14-.73.13-.25-.01-.5-.07-.74-.17-.16-.07-.33-.17-.53-.31.07.15.11.27.11.35,0,.05-.02.14-.06.27-.04.12-.08.21-.12.26l-.74,1.03-1.16-1.23.76-1.12c.1-.14.15-.25.14-.33,0-.11-.06-.21-.15-.31l-.09-.1-1.74.71-1.03-1.1ZM92.47,22.28l.43.46s.16.14.33.27c.09.06.19.11.3.12.11.02.22,0,.31-.03.14-.06.21-.14.22-.24,0-.1-.09-.25-.27-.45l-.45-.48-.87.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.06,24.82l2.12,3.12-1.02.24-1.33-1.96-.76.18,1.23,1.81-.97.23-1.23-1.81-.94.22,1.37,2.01-1.08.26-2.16-3.18,4.77-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.91,14.48l4.02,2.8-.82.64-1.35-.94-2.49,1.94-1.32-.92,2.49-1.94-1.35-.94.82-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.89,18.11l1.19,1.02-3.81,2.19-1.19-1.02,3.81-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.04,21.94l4.28-1.75,1.71,1.82c.32.34.52.61.62.82.1.21.1.4.02.59-.09.19-.27.34-.54.45-.24.1-.48.14-.73.13-.25-.01-.5-.07-.74-.17-.16-.07-.33-.17-.53-.31.07.15.11.27.11.35,0,.05-.02.14-.06.27-.04.12-.08.21-.12.26l-.74,1.03-1.16-1.23.76-1.12c.1-.14.15-.25.14-.33,0-.11-.06-.21-.15-.31l-.09-.1-1.74.71-1.03-1.09ZM92.61,22l.43.46c.05.05.16.14.33.27.09.06.19.11.3.12.11.02.22,0,.31-.03.14-.06.21-.14.22-.24,0-.1-.08-.25-.27-.45l-.45-.48-.87.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.21,24.53l2.12,3.12-1.02.24-1.33-1.96-.76.18,1.23,1.81-.97.23-1.23-1.82-.94.23,1.37,2.01-1.08.26-2.16-3.18,4.77-1.14Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.52,112.22l-5.1-.69v-.95s1.71.23,1.71.23v-2.9s1.67.23,1.67.23v2.9s1.72.23,1.72.23v.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.07,111.21l-1.67-.37.66-3.73,1.67.37-.66,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M44,106.89l-1.35,3.55-2.71-.86c-.5-.16-.88-.31-1.12-.45-.24-.14-.42-.32-.52-.53-.1-.21-.11-.43-.03-.65.07-.2.2-.35.38-.45.18-.1.39-.17.64-.18.16-.01.37,0,.62.04-.18-.11-.3-.19-.37-.27-.05-.05-.11-.14-.19-.27-.08-.13-.13-.23-.14-.29l-.4-1.28,1.84.59.46,1.36c.06.18.12.3.19.37.1.09.22.16.37.21l.14.05.55-1.44,1.63.52ZM41.57,108.48l-.69-.22c-.07-.02-.22-.05-.45-.09-.11-.02-.22-.01-.31.03-.09.04-.15.1-.18.17-.04.11-.02.22.06.31.08.1.27.19.57.29l.71.23.27-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M36.32,108.29l-4.11-1.86.47-.69,2.57,1.16.35-.51-2.38-1.08.45-.66,2.38,1.08.43-.63-2.64-1.2.5-.73,4.18,1.89-2.21,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M52.67,112.54l-5.1-.69v-.95s1.71.23,1.71.23v-2.9s1.67.23,1.67.23v2.9s1.72.23,1.72.23v.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M46.22,111.54l-1.67-.37.66-3.74,1.67.37-.66,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M44.15,107.22l-1.35,3.55-2.71-.86c-.5-.16-.87-.31-1.12-.45-.24-.14-.42-.32-.52-.53-.1-.21-.11-.43-.03-.65.07-.2.2-.35.38-.45.18-.1.39-.17.64-.18.16-.01.37,0,.62.04-.18-.1-.3-.19-.37-.27-.05-.05-.11-.14-.19-.27-.08-.13-.13-.23-.14-.29l-.4-1.28,1.83.59.46,1.36c.06.17.12.3.19.37.1.09.22.16.37.21l.14.05.55-1.44,1.63.52ZM41.72,108.81l-.69-.22c-.07-.02-.22-.05-.45-.09-.11-.02-.22-.01-.31.03-.09.04-.15.1-.18.17-.04.11-.02.22.06.31.08.09.28.19.57.28l.71.23.27-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M36.47,108.62l-4.11-1.86.47-.69,2.57,1.16.35-.51-2.38-1.08.45-.66,2.38,1.08.43-.63-2.64-1.2.5-.73,4.18,1.89-2.21,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.57,105.14l-4.06-2.74.81-.65,1.36.92,2.46-1.98,1.34.9-2.46,1.98,1.36.92-.81.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M24.54,101.59l-1.21-1,3.78-2.25,1.21,1-3.78,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.33,97.73l-4.25,1.81-1.74-1.79c-.32-.33-.53-.6-.63-.81-.1-.21-.11-.4-.02-.59.08-.19.26-.34.53-.46.24-.1.48-.15.73-.14.25,0,.5.06.75.16.16.06.33.17.53.31-.07-.15-.11-.27-.11-.35,0-.06.02-.14.06-.27.04-.12.08-.21.12-.26l.73-1.04,1.18,1.21-.74,1.13c-.1.14-.14.26-.14.33,0,.11.06.21.16.31l.09.1,1.73-.74,1.05,1.08ZM22.75,97.73l-.44-.45s-.16-.13-.33-.26c-.09-.06-.19-.1-.3-.12-.11-.01-.22,0-.31.04-.14.06-.21.14-.21.24,0,.1.09.25.28.45l.46.47.86-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18.12,95.26l-2.17-3.09,1.02-.26,1.36,1.94.76-.19-1.26-1.8.97-.25,1.26,1.8.94-.24-1.4-1.99,1.08-.27,2.21,3.15-4.75,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M29.42,105.44l-4.06-2.74.81-.65,1.36.92,2.46-1.98,1.34.9-2.46,1.98,1.36.92-.81.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M24.39,101.88l-1.21-1,3.78-2.25,1.21,1-3.78,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M26.18,98.02l-4.25,1.81-1.74-1.79c-.32-.33-.53-.6-.63-.81-.1-.21-.11-.4-.02-.59.08-.19.26-.34.53-.46.24-.1.48-.15.73-.14.25,0,.5.06.75.16.16.06.33.16.53.31-.07-.15-.11-.27-.11-.35,0-.05.02-.14.06-.27.04-.12.08-.21.12-.26l.73-1.05,1.18,1.21-.74,1.13c-.1.14-.14.25-.14.33,0,.11.06.21.16.31l.09.09,1.72-.74,1.05,1.08ZM22.61,98.02l-.44-.45s-.16-.14-.33-.26c-.09-.06-.19-.1-.3-.12-.12-.01-.22,0-.31.04-.14.06-.21.14-.21.24,0,.1.09.25.28.45l.46.47.86-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M17.98,95.56l-2.17-3.09,1.01-.26,1.36,1.94.76-.19-1.26-1.8.97-.25,1.26,1.8.94-.24-1.4-1.99,1.08-.27,2.21,3.15-4.75,1.21Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M50.06,65.81h0c2.03,0,3.67,1.65,3.67,3.67h0c0,2.03-1.65,3.68-3.67,3.68h0c-2.03,0-3.67-1.65-3.67-3.67h0c0-2.03,1.65-3.67,3.67-3.67Z",
    transform: "translate(.94 -.67) rotate(.77)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M57.64,43.92h0c2.03,0,3.68,1.65,3.68,3.68h0c0,2.03-1.65,3.67-3.67,3.67h0c-2.03,0-3.67-1.65-3.67-3.67h0c0-2.03,1.65-3.68,3.67-3.68Z",
    transform: "translate(.67 -.8) rotate(.8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,65.81h0c2.03,0,3.67,1.65,3.67,3.67h0c0,2.03-1.65,3.67-3.67,3.67h0c-2.03,0-3.67-1.65-3.67-3.67h0c0-2.03,1.65-3.67,3.67-3.67Z",
    transform: "translate(.94 -.86) rotate(.77)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M45.78,52.68h0c2.03,0,3.67,1.65,3.67,3.67h0c0,2.03-1.65,3.67-3.67,3.67h0c-2.03,0-3.67-1.65-3.67-3.67h0c0-2.03,1.65-3.68,3.67-3.68Z",
    transform: "translate(.76 -.61) rotate(.77)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.88,52.88h2.37c1.37,0,2.49,1.12,2.49,2.49v2.37c0,1.37-1.12,2.49-2.49,2.49h-2.37c-1.37,0-2.49-1.12-2.49-2.49v-2.37c0-1.37,1.12-2.49,2.49-2.49Z",
    transform: "translate(11.58 124.85) rotate(-89.23)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M94.95,83.75c-10.46,13.11-22.73-13.1-23.13-16.37-.15-1.19.02-2.37.3-3.21.28-.84.86-1.88,1.7-2.74,2.23-2.29,26.46-15.05,28.25-.47.25-9.75-2.71-19.46-8.58-27.47,4.03,11.52-20.85,15.11-23.86,14.6-1.18-.2-2.26-.7-2.99-1.21-.73-.51-1.56-1.37-2.14-2.42-1.47-2.66-6.32-27.13,5.7-27.35-9.6-2.84-19.81-2.31-28.95,1.29,15.14-4.16,11.05,23.72,9.61,26.63-.53,1.08-1.32,1.97-2.02,2.51-.7.55-1.76,1.1-2.93,1.35-3.23.7-32.22-2.17-23.05-16.51-.07-.04-.15-.09-.22-.14-.48.6-.94,1.22-1.39,1.86-5.75,8.14-8.38,17.55-8.14,26.8,2.18-13.64,25.93-1.57,28.17.65.85.84,1.45,1.88,1.74,2.71.3.84.48,2.01.35,3.21-.36,3.26-12.15,29.51-22.78,16.84-.02.01-.05.03-.07.04,2.96,4.47,6.77,8.48,11.41,11.76,5.02,3.55,10.53,5.9,16.18,7.13,0-.04.02-.08.03-.12-17.53-5.28,4.2-26.01,7.22-27.46,1.08-.52,2.25-.74,3.14-.73.89,0,2.06.22,3.14.74,2.8,1.35,21.61,19.29,10.41,26.09.01.03.02.05.03.08,8.53-2.93,16.27-8.46,21.87-16.4.38-.54.72-1.09,1.07-1.64-.02-.02-.04-.04-.06-.05Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50.47,72.81h0c-2.02-.03-3.65-1.7-3.62-3.72h0c.03-2.02,1.7-3.65,3.72-3.62h0c2.02.03,3.65,1.7,3.62,3.72h0c-.03,2.02-1.7,3.65-3.72,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.05,50.92h0c-2.02-.03-3.65-1.7-3.62-3.72h0c.03-2.02,1.7-3.65,3.72-3.62h0c2.02.03,3.65,1.7,3.62,3.72h0c-.03,2.02-1.7,3.65-3.73,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.71,72.81h0c-2.02-.03-3.65-1.7-3.62-3.72h0c.03-2.02,1.7-3.65,3.72-3.62h0c2.02.03,3.65,1.7,3.62,3.72h0c-.03,2.02-1.7,3.65-3.72,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.19,59.68h0c-2.02-.03-3.65-1.7-3.62-3.72h0c.03-2.02,1.7-3.65,3.72-3.62h0c2.02.03,3.65,1.7,3.62,3.72h0c-.03,2.02-1.7,3.65-3.72,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.48,59.88h0c-2.02-.03-3.65-1.7-3.62-3.72h0c.03-2.02,1.7-3.65,3.73-3.63h0c2.02.03,3.65,1.7,3.62,3.72h0c-.03,2.02-1.7,3.65-3.72,3.62Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutShape12);
export default __webpack_public_path__ + "static/media/about_shape1-2.59c377f097ab5dace76dedf9f0952806.svg";
export { ForwardRef as ReactComponent };